import { Record, Map } from 'immutable'
import _ from 'lodash'

import {
    EXPORTS_TASK_RECEIVED,
    EXPORTS_JOB_ADD_WATCHER,
    EXPORTS_JOB_REMOVE_WATCHER,
    EXPORTS_TASK_REMOVE,
    EXPORTS_SET_LOADING_TRUE,
    EXPORTS_SET_LOADING_FALSE,
    EXPORTS_SET_LOADED_TRUE,
} from './constants'

const initialState = Record(
    {
        loading: false,
        loaded: false,
        jobs: Map(),
    },
    'ExportsContent reducer initial state'
)

export default (state = initialState(), action = {}) => {
    switch (action.type) {
        case EXPORTS_TASK_RECEIVED: {
            const jobId = action?.data?.jobId
            const jobData = action?.data?.data

            if (!jobId || _.isEmpty(jobData)) return state

            return state.setIn(['jobs', jobId], jobData)
        }
        case EXPORTS_JOB_ADD_WATCHER: {
            const jobId = action?.data?.jobId

            if (!jobId) return state

            return state.setIn(['jobs', jobId, 'active'], true)
        }
        case EXPORTS_JOB_REMOVE_WATCHER(action?.data?.jobId): {
            const jobId = action?.data?.jobId

            if (!jobId) return state

            return state.setIn(['jobs', jobId, 'active'], false)
        }
        case EXPORTS_TASK_REMOVE(action?.data?.jobId): {
            const jobId = action?.data?.jobId

            if (!jobId) return state

            return state.removeIn(['jobs', jobId])
        }
        case EXPORTS_SET_LOADING_TRUE: {
            return state.set('loading', true)
        }
        case EXPORTS_SET_LOADING_FALSE: {
            return state.set('loading', false)
        }
        case EXPORTS_SET_LOADED_TRUE: {
            return state.set('loaded', true)
        }
        default:
            return state
    }
}
